import { useEffect, useRef } from "react";
import { Box, CircularProgress, Typography } from "@mui/joy";
import { useNavigate } from "react-router-dom";

import { useAuthentication, useUserRoles } from "../../hooks/query";
import { useAuth, useSearchParams } from "../../hooks";

export default function AuthCallback() {
    const searchParams = useSearchParams();
    const navigate = useNavigate();
    const { setIsAuthenticated, setUser, setToken, setRoles, isAuthenticated } = useAuth();
    const hasProcessed = useRef(false);

    const { useListByUser } = useUserRoles();
    const { useCodeExchange } = useAuthentication();
    const codeExchangeSvc = useCodeExchange();
    const listRoleByUserSvc = useListByUser();

    const fetchData = async () => {
        // Prevent duplicate requests
        if (hasProcessed.current || isAuthenticated) {
            return;
        }

        try {
            const code = searchParams.get("code");
            if (!code) return;

            hasProcessed.current = true;
            const response = await codeExchangeSvc.mutateAsync({
                Code: searchParams.get("code"),
                State: searchParams.get("state"),
            });
            const listRoleByUserResponse = await listRoleByUserSvc.mutateAsync({ UserId: response.UserId });

            // Persist roles in auth context so permission checks work immediately after login
            setRoles(listRoleByUserResponse);

            const newUser = { user: {}, roles: listRoleByUserResponse };
            setUser(newUser);
            setToken(response.IdToken || response.AccessToken);
            setIsAuthenticated(true);
        } catch (error) {
            console.log(error);
            hasProcessed.current = false; // Reset on error so it can retry
        }
    };

    useEffect(() => {
        fetchData().then();
    }, []);

    useEffect(() => {
        if (isAuthenticated) {
            navigate("/");
        }
    }, [isAuthenticated]);

    return (
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"} justifyContent={"center"} height={"100%"}>
            <CircularProgress size="sm" sx={{ mb: 2 }} />
            <Typography level="body-md">Preparing your work site... </Typography>
        </Box>
    );
}
